import React from 'react';
import './Controls.css';

const Controls = ({ onPause, onHelp, isPaused }) => {
  return (
    <div className="controls">
      <button 
        className="control-btn help-btn" 
        onClick={onHelp}
        aria-label="Help"
      >
        ?
      </button>
      <button 
        className="control-btn pause-btn" 
        onClick={onPause}
        aria-label={isPaused ? "Resume" : "Pause"}
      >
        {isPaused ? '▶️' : '⏸️'}
      </button>
    </div>
  );
};

export default Controls;

